export const AlarmLevels = ['low', 'medium', 'high']
export const ThresholdTypeValues = ['percentage', 'absolute']
export const ThresholdRules = ['lower', 'not equal', 'higher']